import React from 'react';

import { HomeCardFront } from '../home-card-front';

export interface HomeNetworkCardFrontProps
  extends Readonly<{
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeNetworkCardFront = React.memo<HomeNetworkCardFrontProps>((props) => {
  const { onButtonPress, style } = props;

  return (
    <HomeCardFront
      icon={'network'}
      iconColor={'tertiary'}
      title={'Ensure superior network performance'}
      onButtonPress={onButtonPress}
      style={style}
    />
  );
});
